import React from "react"
import PageTemplate from "../components/pageTemplate"
import { Container, Row, Col } from "reactstrap"
import { FaCode, FaRegClipboard, FaRegAddressBook, FaHome, FaHandsHelping, FaProjectDiagram } from "react-icons/fa"
import {
    RiSettings6Line,
    RiDeleteBack2Fill,
    RiDatabase2Line
} from "react-icons/ri"
import {
    BiTransfer, BiCalendarEdit, BiCalendarCheck
} from "react-icons/bi"
import {
    HiOutlineDocumentText
} from "react-icons/hi"
import {
    FiTrash2
} from "react-icons/fi"
import Box from "../components/box"
import SEO from "../components/seo"
import Button from "../components/btn"
// import "bootstrap/dist/css/bootstrap.min.css"

let Portfolio = ({ title, description, example }) => (
    <Col xs={12} md={12} className="mb-4">
        {/* <Link to="/"> */}
        {/* <Icon size={40} style={{display: 'inline-block', borderRadius: '60px', padding: '0.7em 0.6em', color:"white", backgroundColor: '#b23a48'}}/> */}

        <p className="mt-3" style={{ fontWeight: 'bold' }}>{title}</p>
        <p className="mt-3">{description}</p>

        <p className="mt-3">{example}</p>
        {/* </Link> */}
    </Col>
)

let CareerInfo = ({ Icon = FaHome, title, content }) => (
    <div className="d-flex mb-4">
        {/* <div><FaCode size={20} style={{color: '#f77f00'}} /></div> */}
        <div>
            <Icon size={40} style={{ display: 'inline-block', borderRadius: '60px', padding: '0.7em 0.6em', color: "white", backgroundColor: '#A00429' }} />
        </div>
        <div className="ml-3">
            <p className="m-0" style="font-weight: bold;">{title}</p>
            <p className="m-0 text-muted">{content}</p>
        </div>
    </div>
)

let IconCareer = ({ Icon = FaHome }) => (
    <Icon size={40} style={{ display: 'inline-block', borderRadius: '60px', padding: '0.7em 0.6em', color: "white", backgroundColor: '#A00429' }} />
)

let Career = () => (
    <PageTemplate title="Career">
        <SEO title="Career" />
        <Container className="py-5">
            <h2 className="text-center mb-5" style={{ fontWeight: '900' }}>Software Developer • System Engineer</h2>
            <Col xs={12} md={12} className="mb-4">
                <Row>
                    <Box>
                        <Row>
                            <Col xs={12} md={6} className="mb-4">
                                <p className="mt-3" style={{ fontWeight: 'bold' }}>Key Responsibilities</p>
                                <p className="mt-3">Participate in the entire product lifecycle of new and existing projects.</p>
                                <p className="mt-3">Manage and maintain on up-and-coming products.</p>
                                <p className="mt-3">Maintain and review existing developers' code.</p>
                                <p className="mt-3">Write test cases for code (new or existing code).</p>
                                <p className="mt-3">Produce results effectively and within the deadlines set.</p>
                                <p className="mt-3">Design and develop web-based applications using PHP and other programming languages.</p>
                                <p className="mt-3">Collaborate with cross-functional teams to define, design, and ship new features and improve existing applications.</p>
                                <p className="mt-3">Perform code reviews and provide feedback to other developers.</p>
                                <p className="mt-3">Write clean, maintainable, secured, and efficient code.</p>
                                <p className="mt-3">Troubleshoot and debug applications.</p>
                                <p className="mt-3">Stay up-to-date with new programming languages and technologies.</p>

                        
                            </Col>
                            <Col xs={12} md={6} className="mb-4">
                                <p className="mt-3" style={{ fontWeight: 'bold' }}>Experience and Required Skills</p>
                                <p className="mt-3">At least 1 year programming experience or  1-3 project(s) with Laravel framework (or other PHP framework).</p>
                                <p className="mt-3">Preferable Technical Stacks:  PHP, Laravel, MySQL, HTML, CSS, and JavaScript, jQuery, Ajax, Bootstrap, Git.</p>
                                <p className="mt-3">Proficient in Linux is a plus.</p>
                                <p className="mt-3">REST API experience is a plus.</p>
                                <p className="mt-3">General knowledge about HTTP status code.</p>
                                <p className="mt-3">Strong coding skills, good logical and problem-solving skills.</p>
                                <p className="mt-3">Proficient understanding of clean code principles.</p>
                                <p className="mt-3">Strong communication and collaboration skills.</p>
                            </Col>
                            <Col xs={12} md={4} className="mb-4">
                                <p className="mt-3" style={{ fontWeight: 'bold' }}>Career Level</p>
                                <p className="mt-3">
                                    Junior Executive and above depending on experiences
                                </p>
                            </Col>
                            <Col xs={12} md={4} className="mb-4">
                                <p className="mt-3" style={{ fontWeight: 'bold' }}>Estimate Salary</p>
                                <p className="mt-3">
                                    RM 2500 - RM 5000
                                </p>
                            </Col>
                            <Col xs={12} md={4} className="mb-4">
                                <p className="mt-3" style={{ fontWeight: 'bold' }}>Qualification</p>
                                <p className="mt-3">
                                    Diploma or Degree in Information Technology or a similar technical field of study, or equivalent practical experience
                                </p>
                            </Col>
                            <Col xs={12} md={4} className="mb-4">
                                <p className="mt-3" style={{ fontWeight: 'bold' }}>Years of Experience</p>
                                <p className="mt-3">
                                    1 year and above
                                </p>
                            </Col>
                            <Col xs={12} md={4} className="mb-4">
                                <p className="mt-3" style={{ fontWeight: 'bold' }}>Job Type</p>
                                <p className="mt-3">
                                    Contract / Fulltime
                                </p>
                            </Col>
                            <Col xs={12} md={4} className="mb-4">
                                <p className="mt-3" style={{ fontWeight: 'bold' }}>Job Specializations</p>
                                <p className="mt-3">
                                    Information Technology / Software Engineering / Web Development / Mobile Application Development
                                </p>
                            </Col>
                            <Col xs={12} md={4} className="mb-4">
                                <p className="mt-3" style={{ fontWeight: 'bold' }}>Contact</p>
                            
                                <p className="mt-3">
                                    <a href="mailto:hr@2q.my">hr@2q.my</a>
                                </p>
                            </Col>
                        </Row>
                    </Box>
                </Row>
            </Col>
        </Container>
    </PageTemplate>
)

export default Career